import Backbone from 'backbone';
import _ from 'underscore';
import React from 'react';
import ReactDOM from 'react-dom';
import { Scopes } from './config/constants';
import { CampaignGoalLevelEditor } from './goal-scope-selector';
import { convertToMTFormat } from './utils';

export class GoalSelectorView extends Backbone.View {
  initialize({
    i18n,
    stringKeys,
    checkSelected,
    pageSize,
    ariaLabel = '',
    searchBoxAriaLabel = '',
    isMultiMode,
    isHideSaveBar,
    campaign,
    jsdata,
    state,
    turnOnRemoveAlert = _.noop,
    activityLogger,
  }) {
    // SPA Campaign:
    const isSPA = campaign.CampaignSubType === 'ShoppingSponsoredProductAd';
    // Cashback CPS Campaign:
    const isCPS = campaign.CampaignCashback != null &&
      (campaign.CampaignCashback.PersonalizedOffersEnabled === true
        || campaign.CampaignCashback.MonthlyBudget > 0);

    this.isSelectorEnabled = !isSPA && !isCPS;

    this.goalScopeSelection = Scopes.ACCOUNT;
    this.campaignConversionGoal = campaign.CampaignConversionGoal;
    this.goalSelection = this.campaignConversionGoal ?
      this.campaignConversionGoal.Goals : [];
    this.originalGoalSelection = this.goalSelection;

    this.i18n = i18n;
    this.stringKeys = stringKeys;
    this.checkSelected = checkSelected;
    this.pageSize = pageSize;
    this.ariaLabel = ariaLabel;
    this.searchBoxAriaLabel = searchBoxAriaLabel;
    this.isMultiMode = isMultiMode;
    this.isHideSaveBar = isHideSaveBar;
    this.fetch = this.fetchConversionGoal(jsdata, state, i18n);
    this.onSelectDone = this.onSelectDone.bind(this);
    this.onScopeChange = this.onScopeChange.bind(this);
    this.turnOnRemoveAlert = turnOnRemoveAlert;
    this.activityLogger = activityLogger;
  }

  onSelectDone(selectedGoals) {
    this.goalSelection= selectedGoals;
  }

  onScopeChange(newScopeSelection) {
    this.goalScopeSelection = newScopeSelection;
  }

  convertToMTFormat = campaignId => convertToMTFormat(
    campaignId,
    this.goalScopeSelection,
    this.originalGoalSelection,
    this.goalSelection,
    this.isSelectorEnabled
  );

  fetchConversionGoal(jsdata, state, i18n) {
    return ({ query, pageNumber, pageSize }) => {
      const formatDate = date => i18n.formatDate(date, { raw: 'M/d/yyyy' });

      return state.getPromise('$daterange').then((dateRange) => {
        const dateQuery = {
          $top: pageSize,
          $skip: pageNumber * pageSize,
          startdate: formatDate(dateRange.start),
          enddate: formatDate(dateRange.end),
          $filter: '(Status eq Enum.GoalStatus\'Active\') and ((GoalCategory eq Enum.GoalCategory\'InStoreVisit\') eq false)',
          $select: 'Id, Name, GoalCategory, Status',
          $orderby: 'Name asc',
          $count: true,
        };

        if (query) {
          dateQuery.$filter = `${dateQuery.$filter} and contains(tolower(Name), tolower('${query}'))`;
        }
        const options = {
          headers: {
            'x-ms-refreshcampaigncache': 'true',
          },
        };

        return jsdata.Goal.findAll({
          query: dateQuery,
          select: ['Id', 'Name', 'GoalCategory', 'Status'],
        }, options).then((cmps) => {
          const { totalCount } = cmps;
          const items = _.compact(_.map(cmps, cmp => ({
            Id: cmp.Id,
            Name: cmp.Name,
            GoalCategory: cmp.GoalCategory,
            Status: cmp.Status,
          })));
          return {
            items,
            totalCount,
          };
        })
          .catch(() =>
            ({
              items: [],
              totalCount: 0,
            }));
      });
    };
  }
  render() {
    ReactDOM.render(this.isSelectorEnabled ?
      (
        <CampaignGoalLevelEditor
          i18n={this.i18n}
          fetch={this.fetch}
          onSelectDone={this.onSelectDone}
          selectedItem={null}
          selectedItemsForMultiMode={this.goalSelection}
          checkSelected={this.checkSelected}
          pageSize={this.pageSize}
          ariaLabel={this.ariaLabel}
          searchBoxAriaLabel={this.searchBoxAriaLabel}
          isMultiMode={this.isMultiMode}
          isHideSaveBar={this.isHideSaveBar}
          campaignConversionGoal={this.campaignConversionGoal}
          onScopeChange={this.onScopeChange}
          turnOnRemoveAlert={this.turnOnRemoveAlert}
          activityLogger={this.activityLogger}
        />
      ) : (<div className="disable-goal-selector" />), this.el);
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
